<div *ngIf="selectedEventTicket$ | async as eventTicket" class="gb-event-ticket-assign-dialog">
  <gb-event-ticket-guest-stepper
    [config]="{
      title: 'SHARED.EVENT_TICKETS.ASSIGN_TICKET.HEADER',
      buttonLabel: 'SHARED.EVENT_TICKETS.ASSIGN_TICKET.ASSIGN_BUTTON',
      shouldPrepopulateForm: !isAdminOrVolunteer,
    }"
    (onSubmitEvent)="onSubmit($event)"
  >
    <p>
      <span
        [innerHTML]="
          'SHARED.EVENT_TICKETS.ASSIGN_TICKET.DESCRIPTION' | translate: { name: eventTicket.ticket_package.name }
        "
      ></span>
      <strong *ngIf="eventTicket.ticket_package.tickets_included > 1">
        - {{ eventTicket.seat_number | gbEventTicketSeatLabel }}</strong
      >.
    </p>
  </gb-event-ticket-guest-stepper>
</div>
